import React from "react";
import {
  FiAward,
  FiBookOpen,
  FiStar,
  FiFileText,
  FiZap,
  FiCalendar,
  FiTrendingUp,
} from "react-icons/fi";
import "./MilestonePost.css";

const MilestonePost = ({ post }) => {
  if (!post || !post.milestone) {
    return (
      <div className="cbx-ms cbx-ms--error">
        <p>Error: Milestone data is missing</p>
      </div>
    );
  }

  const milestone = post.milestone;

  if (!milestone.title) {
    return (
      <div className="cbx-ms cbx-ms--error">
        <p>Error: Invalid milestone data</p>
      </div>
    );
  }

  const getMilestoneIcon = () => {
    const icons = {
      paper_published: FiFileText,
      paper_accepted: FiFileText,
      grant_awarded: FiAward,
      phd_defense: FiBookOpen,
      conference_talk: FiStar,
      award_received: FiAward,
      patent_granted: FiZap,
      project_completed: FiTrendingUp,
    };
    const Icon = icons[milestone.type] || FiAward;
    return <Icon />;
  };

  const getMilestoneLabel = () => {
    const labels = {
      paper_published: "Paper Published",
      paper_accepted: "Paper Accepted",
      grant_awarded: "Grant Awarded",
      phd_defense: "PhD Defense",
      conference_talk: "Conference Talk",
      award_received: "Award Received",
      patent_granted: "Patent Granted",
      project_completed: "Project Completed",
    };
    return labels[milestone.type] || "Milestone";
  };

  return (
    <div className="cbx-ms">
      {/* Milestone Header Card */}
      <div className="cbx-ms__card">
        <div className="cbx-ms__accent" />

        <div className="cbx-ms__header">
          <div className="cbx-ms__icon-wrap">
            {getMilestoneIcon()}
          </div>
          <div className="cbx-ms__header-info">
            <span className="cbx-ms__label">{getMilestoneLabel()}</span>
            <h3 className="cbx-ms__title">{milestone.title}</h3>
            {milestone.venue && (
              <p className="cbx-ms__venue">{milestone.venue}</p>
            )}
          </div>
        </div>

        {milestone.description && (
          <div className="cbx-ms__desc-block">
            <p className="cbx-ms__description">{milestone.description}</p>
          </div>
        )}

        {/* Date and additional info */}
        <div className="cbx-ms__footer">
          {milestone.date && (
            <span className="cbx-ms__date">
              <FiCalendar />
              {new Date(milestone.date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </span>
          )}
        </div>
      </div>

      {post.content && (
        <p className="cbx-ms__additional">{post.content}</p>
      )}
    </div>
  );
};

export default MilestonePost;
